'use strict'

import 'bootstrap'
import InsertFontAwesomeIcons from './Components/InsertFontAwesomeIcons'
import LazyLoader from './Components/LazyLoader'

export default class Application {
  constructor () {
    this
      ._initializeInsertFontAwesomeIcons()
      ._initializeLazyLoader()

    return this
  }

  _initializeInsertFontAwesomeIcons () {
    (() => new InsertFontAwesomeIcons().enable())()

    return this
  }

  _initializeLazyLoader () {
    (() => new LazyLoader('img.lazy'))()

    return this
  }
}
